import { Button, Icon, useSidebar } from '@eluve/components';
import { useTranslation } from '@eluve/i18n';
import { useIsFeatureFlagEnabled } from '@eluve/smart-blocks';

import { useTranscriptionMachineSelector } from '../appointments/machines/transcription/hooks/useTranscriptionMachine';
import { useStartAnonymousSession } from '../hooks/useStartAnonymousSession';

export const NewAppointmentButton: React.FC = () => {
  const { t } = useTranslation();
  const { isMobile } = useSidebar();
  const { startSession, isPending } = useStartAnonymousSession();
  const shouldHideNewAppointmentButton = useIsFeatureFlagEnabled(
    'HIDE_NEW_SESSION_BUTTON',
  );

  // Show button when not actively recording: Idle, Paused, or validating audio
  // ValidatingAudioCapture occurs when checking mic status (e.g., muted or no audio)
  const canStartAppointment = useTranscriptionMachineSelector(
    (s) =>
      s.matches('Idle') ||
      s.matches({ InSession: 'Paused' }) ||
      s.matches('ValidatingAudioCapture'),
  );

  if (!canStartAppointment) {
    return null;
  }

  if (shouldHideNewAppointmentButton) {
    return null;
  }

  return (
    <Button
      onClick={startSession}
      loading={isPending}
      data-accessibility-label="new-session-button"
    >
      {!isMobile && <Icon name="Plus" size="auto" />}
      {t('common.newSession')}
    </Button>
  );
};
